import posthog from "src/consent/posthog"
import { planOffers } from "src/components/reports/reportPricing"
import type { SubscriptionPlanKey } from "./Subscription"

/** The flow every event here belongs to, carried on each as a property to filter a funnel by. */
export const SUBSCRIPTION_PAY_FLOW = "subscription-pay-flow"

/** The single monthly plan, offered when the visitor is shown no plans to choose from. */
export const MONTHLY_PLAN = "month"
const MONTHLY_PRICE_EUR = 5

/** The funnel from the plans pop up to a paid plan; subscription_paid is sent by the server from the Stripe webhook. */
export type SubscriptionPayFlowEvent =
    | "subscription_plans_viewed"
    | "subscription_pay_button_clicked"
    | "subscription_signed_in"

export function planPriceEur(plan?: SubscriptionPlanKey): number | null {
    if (!plan) return MONTHLY_PRICE_EUR
    return planOffers().find(offer => offer.plan === plan)?.amount_eur ?? null
}

/** Records one step of the flow for the plan it happened on. */
export function trackSubscriptionPayFlow(
    event: SubscriptionPayFlowEvent,
    properties: Record<string, any> = {},
) {
    posthog?.capture(event, { flow: SUBSCRIPTION_PAY_FLOW, ...properties })
}
